<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <span class="text-indigo-400 font-medium">Payment /</span>
      <inertia-link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('admin.krs.show', studentReport.id)">
        {{ mahasiswa.name }} [{{ studentReport.school_semester }}-{{
          studentReport.school_year
        }}]
      </inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Create
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input
            :value="mahasiswa.name"
            class="pr-6 pb-8 w-full md:w-1/2"
            input-class="bg-gray-200"
            label="Nama Lengkap Mahasiswa"
            disabled />
          <div class="w-full" />
          <text-input
            :value="studentReport.school_year.toString()"
            class="pr-6 pb-8 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="Tahun Ajaran"
            disabled />
          <text-input
            :value="studentReport.school_semester.toString()"
            class="pr-6 pb-8 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="Semester"
            disabled />
          <text-input
            :value="studentReport.krs_sks.toString()"
            class="pr-6 pb-6 w-full lg:w-1/3"
            input-class="bg-gray-200"
            label="SKS KRS"
            disabled />
          <text-input
            value="[AUTO GENERATED]"
            class="pr-6 pb-8 w-full lg:w-2/5"
            label="No Transaksi Bayar"
            input-class="bg-gray-200"
            disabled />
          <text-input
            v-model="form.bank_trans_no"
            :error="form.errors.bank_trans_no"
            class="pr-6 pb-8 w-full lg:w-2/5"
            label="No Transaksi Bank" />
          <text-input
            v-model="form.payment_date"
            v-mask="'##/##/####'"
            :error="form.errors.payment_date"
            class="pr-6 pb-8 w-full lg:w-1/5"
            input-class="text-center"
            label="Tanggal Transaksi"
            placeholder="dd/mm/yyyy" />
          <select-input
            v-model="form.scholarship_bank_id"
            :error="form.errors.scholarship_bank_id"
            class="pr-6 pb-8 w-full md:w-1/3"
            label="Bank Tujuan">
            <option :value="null" />
            <option
              v-for="bank in banks"
              :key="bank.id"
              :value="bank.id">
              {{ bank.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.scholarship_bank_acc_name"
            :error="form.errors.scholarship_bank_acc_name"
            class="pr-6 pb-8 w-full md:w-1/3"
            label="Rekening Tujuan" />
          <text-input
            v-model="form.scholarship_bank_acc_number"
            :error="form.errors.scholarship_bank_acc_number"
            class="pr-6 pb-8 w-full md:w-1/3"
            label="No. Rekening Tujuan" />
          <file-input
            v-model="form.payment_file"
            :error="form.errors.payment_file"
            class="pr-6 pb-8 w-full md:w-2/3"
            type="file"
            accept="image/jpeg,image/png,image/gif,image/bmp,image/webp"
            label="Bukti Pembayaran (File)" />
          <select-input
            v-model="form.payment_period"
            :error="form.errors.payment_period"
            class="pr-6 pb-8 w-full md:w-1/3"
            label="Periode Pembayaran">
            <option
              :value="null"
              disabled
              class="text-center font-light italic">
              -- PILIH PERIODE --
            </option>
            <option value="GANJIL">
              GANJIL
            </option>
            <option value="GANJIL">
              GENAP
            </option>
          </select-input>
          <number-input
            v-model="form.payment_amount"
            :error="form.errors.payment_amount"
            class="pr-6 pb-8 w-full md:w-2/3"
            input-class="text-right"
            label="Jumlah Pembayaran" />
          <select-input
            v-model="form.bank_status_payment_id"
            :error="form.errors.bank_status_payment_id"
            class="pr-6 pb-8 w-full md:w-1/3"
            label="Status Pembayaran">
            <option
              v-for="option in optionsStatusBayar"
              :key="option.id"
              :value="option.id">
              {{ option.status }}
            </option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button
            :loading="form.processing"
            class="btn-indigo"
            type="submit">
            Save
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="js">
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import NumberInput from '@/Shared/NumberInput'
import LoadingButton from '@/Shared/LoadingButton'
import { format } from 'date-fns'
import { useForm, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'Create Scholarship Payment' },
    components: {
        FileInput,
        LoadingButton,
        SelectInput,
        TextInput,
        NumberInput,
        'inertia-link': Link,
    },
    layout: Layout,
    remember: 'form',
    props: {
        studentReport: Object,
        mahasiswa: Object,
        banks: Array,
        optionsStatusBayar: Array,
    },
    data () {
        return {
            form: useForm({
                student_report_id: this.studentReport.id,
                payment_date: format(new Date(), 'dd/MM/yyyy'),
                bank_trans_no: null,
                payment_period: null,
                payment_amount: 0,
                bank_status_payment_id: 6,
                payment_file: null,
                scholarship_bank_id: this.mahasiswa.ref_bank_id,
                scholarship_bank_acc_name: this.mahasiswa.bank_acc_name,
                scholarship_bank_acc_number: this.mahasiswa.bank_acc_number,
            }),
        }
    },
    methods: {
        store () {
            this.form.post(this.route('payment.store'))
        },
    },
}
</script>
